// Centralized debug logger utility. Safe no-op in production unless window.__DEBUG_FORCE is set.
export function debugLog(domain, message, data) {
  try {
    const ts = new Date().toISOString();
    const force = (typeof window !== 'undefined') && window.__DEBUG_FORCE;
    if (process.env.NODE_ENV !== 'development' && !force) return; // Only verbose in dev unless forced
    if (data !== undefined) {
      // eslint-disable-next-line no-console
      console.log(`[DBG ${ts}] [${domain}] ${message}`, data);
    } else {
      // eslint-disable-next-line no-console
      console.log(`[DBG ${ts}] [${domain}] ${message}`);
    }
  } catch (_) {
    // swallow logging errors
  }
}

export function debugWarn(domain, message, data) {
  try {
    const ts = new Date().toISOString();
    const force = (typeof window !== 'undefined') && window.__DEBUG_FORCE;
    if (process.env.NODE_ENV !== 'development' && !force) return;
    if (data !== undefined) {
      // eslint-disable-next-line no-console
      console.warn(`[DBG ${ts}] [${domain}] ${message}`, data);
    } else {
      // eslint-disable-next-line no-console
      console.warn(`[DBG ${ts}] [${domain}] ${message}`);
    }
  } catch (_) {}
}

export function debugError(domain, message, data) {
  try {
    const ts = new Date().toISOString();
    const force = (typeof window !== 'undefined') && window.__DEBUG_FORCE;
    if (process.env.NODE_ENV !== 'development' && !force) return;
    if (data !== undefined) {
      // eslint-disable-next-line no-console
      console.error(`[DBG ${ts}] [${domain}] ${message}`, data);
    } else {
      // eslint-disable-next-line no-console
      console.error(`[DBG ${ts}] [${domain}] ${message}`);
    }
  } catch (_) {}
}
